import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'

import MultiplyByAEqualsUnknown from './components/MultiplyByAEqualsUnknown'
import MultiplyByUnknown from './components/MultiplyByUnknown'

export default function MultiplyByA(props: ActivityProps): React.ReactElement {
  return props.activityType % 2 === 0 ? <MultiplyByUnknown {...props} /> : <MultiplyByAEqualsUnknown {...props} />
}
